import { ActionContext } from '../../../cra'
import { AiOutlinePaperClip } from 'react-icons/ai'
import { MdEdit, MdDeleteOutline } from 'react-icons/md'
import ApiManager from '../../../api/ApiManager'
import BouncingDotsLoader from '../../common/Loading/BouncingDotsLoader'
import Button from '../../common/Button/Button.component'
import { HttpMethods } from '../../../enums/HttpMethodsEnum'
import Icon from '../../common/Icon/Icon.component'
import DeleteConfirmationModal from '../../common/Modal/DeleteConfirmationModal'
import ModalComponent from '../../common/Modal/Modal.component'
import OverlayLoader from '../../common/OverlayLoader/OverlayLoader'
import { PrescriptionDrug } from '../../../interface/prescriptionDrug/PrescriptionDrug'
import { PrescriptionDrugFrequencyEnum } from '../../../enums/PrescriptionDrugFrequencyEnum'
import QuotesRefreshProvider from '../../../context/QuotesRefreshContext'
import React from 'react'
import RefreshDrugCostModal from '../../DashboardPage/Modals/RefreshDrugCostModal'
import SearchPromptComponent from './SearchPrompt.Component'
import SecureComponent from '../../../pages/common/SecureComponent'
import StringConstants from '../../../constants/StringConstants'
import UrlConstants from '../../../constants/UrlConstants'
import customerStore from '../../../datastore/CustomerStore'
import { capitalizeFirstCharacter, toSentenceCase } from '../../../utils/StringUtils'
import { deletePrescription } from '../../../service/prescriptions'
import { getPlanYear } from '../../../utils/CommonUtils'
import { isUndefined } from 'lodash'
import mPartDPlansFilterStore from '../../../datastore/medicareQuotes/MPartPlanFilterQuotesStore'
import medicareAdvantageFilterQuoteStore from '../../../datastore/medicareQuotes/MedicareAdvantageFilterQuoteStore'
import { observer } from 'mobx-react'
import { pollQuotesPullStatus } from '../../../utils/quotesPullStatus'
import snackbarStore from '../../../datastore/SnackbarStore'
import styled from '@emotion/styled'
import theme from '../../../global/theme'
import { withRouter } from '../../common/WithRouter/WithRouter.component'
import { SnackbarTypes } from '../../../enums/SnackbarTypesEnum'

interface AddPrescriptionProps {
  handleNext?: () => void
  isSpouse?: boolean
  redirect?: boolean
  pathContext?: string
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const UpperDiv = styled.div`
  margin-bottom: 20px;
`

const AddedDrugsWrapper = styled.div`
  border-top: 1px solid ${theme.colors.borderColor};
  padding-top: 20px;
`

const AddedDrugsHeader = styled.div`
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${theme.colors.textGrey};
  padding-bottom: 4px;
`

const TableWrapper = styled.div`
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid ${theme.colors.borderColor};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-top: 12px;
`

const EntryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`

const Th = styled.th`
  text-align: left;
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 600;
  color: ${theme.colors.textGrey};
  border-bottom: 1px solid ${theme.colors.borderColor};
  background: ${theme.colors.backgroundColorContainer};
  text-transform: uppercase;
  letter-spacing: 0.4px;
`

const Td = styled.td`
  padding: 11px 14px;
  border-bottom: 1px solid ${theme.colors.borderColor};
  vertical-align: middle;
  color: ${theme.colors.textDark};
  font-size: 13px;
`

const ActionsTd = styled.td`
  padding: 10px 14px;
  border-bottom: 1px solid ${theme.colors.borderColor};
  vertical-align: middle;
  white-space: nowrap;
  width: 1%;
`

const IconBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  color: ${theme.colors.textGrey};
  line-height: 0;
  transition: color 0.15s, background 0.15s;
  &:hover { color: ${theme.colors.primary}; background: ${theme.colors.backgroundColorContainer}; }
`

const DeleteIconBtn = styled(IconBtn)`
  margin-left: 2px;
  &:hover { color: #e53935; background: #fdecea; }
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: -3.5rem;
  margin-bottom: 0.5rem;
  padding-right: 22px;
`

const AddPrescription: React.FC<AddPrescriptionProps> = ({
  handleNext,
  isSpouse,
  redirect = true,
  pathContext = 'Profile',
}) => {
  const [loading, setLoading] = React.useState<boolean>(true)
  const [addDrugLoading, setAddDrugLoading] = React.useState<boolean>(false)
  const [deleteDrugLoading, setDeleteDrugLoading] =
    React.useState<boolean>(false)
  const [isEditDrug, setIsEditDrug] = React.useState(false)
  const [pendingDeleteDrug, setPendingDeleteDrug] = React.useState<any>(null)
  const [addPrescriptionState, setAddPrescriptionState] = React.useState<{
    AddedDrugs: PrescriptionDrug[]
    PrescriptionDrug: any[]
    addingDrugs: boolean
  }>({
    AddedDrugs: [],
    PrescriptionDrug: [],
    addingDrugs: false,
  })
  const [forSpouse, setForSpouse] = React.useState(
    isUndefined(isSpouse) ? customerStore.forSpouse : isSpouse
  )

  const [isDrugCostsToBeRefreshed, setIsDrugCostsToBeRefreshed] =
    React.useState<boolean>(false)

  const [isDrugCostsRefreshToBeDisplayed, setIsDrugCostsRefreshToBeDisplayed] =
    React.useState<boolean>(false)

  const [isOverlayLoading, setIsOverlayLoading] = React.useState<boolean>(false)

  // const [millimanModalOpen, setMillimanModalOpen] =
  //   React.useState<boolean>(false)

  const { trackCurrentPage } = React.useContext(ActionContext)

  React.useEffect(() => {
    trackCurrentPage(
      `${pathContext === 'infoSteps' ? 'Info Steps -' : 'Profile -'} ${
        customerStore.forSpouse
          ? "Spouse/Partner’s Prescriptions"
          : 'Prescriptions'
      }`
    )
    setForSpouse(customerStore.forSpouse)
  }, [customerStore.forSpouse])

  React.useEffect(() => {
    if (addPrescriptionState.AddedDrugs.length > 0) {
      const currentMonth = new Date().getMonth() + 1
      addPrescriptionState.AddedDrugs.forEach((drug) => {
        if (new Date(drug.drugCostUpdatedAt).getMonth() + 1 < currentMonth) {
          setIsDrugCostsToBeRefreshed(true)
          return
        }
      })
    }
  }, [addPrescriptionState])

  const handleOkRefreshDrugCost = () => {
    setIsDrugCostsToBeRefreshed(false)
    setIsOverlayLoading(true)
    ApiManager.makeApiCallWithAuthentication(
      UrlConstants.REFRESH_DRUG_COST.USECASE,
      HttpMethods.GET_METHOD,
      { 'for-spouse': forSpouse }
    )
      .then(() => {
        snackbarStore.set({
          snackbarOpen: true,
          snackbarMessage: 'Drug cost refreshed successfully',
          snackbarType: 'success',
        })
      })
      .catch(() => {
        snackbarStore.set({
          snackbarOpen: true,
          snackbarMessage: 'Unable to refresh drug cost',
          snackbarType: 'error',
        })
      })
      .finally(() => {
        setIsOverlayLoading(false)
      })
  }

  const getFrequencyLabel = (freq: any) => {
    const f = String(freq)
    if (f === PrescriptionDrugFrequencyEnum.EveryMonth) return 'every month'
    if (f === PrescriptionDrugFrequencyEnum.EveryTwoMonths) return 'every 2 months'
    if (f === PrescriptionDrugFrequencyEnum.EveryThreeMonths) return 'every 3 months'
    if (f === PrescriptionDrugFrequencyEnum.EverySixMonths) return 'every 6 months'
    return 'every 12 months'
  }

  const handleEditDrug = (data: any) => {
    setIsEditDrug(true)
    const tempPrescriptionDrug = addPrescriptionState.AddedDrugs.filter(
      (item) => item.id === data.id
    )[0]
    const prescriptionDrugForEditing = {
      ...tempPrescriptionDrug,
      title: tempPrescriptionDrug.name,
      dosage: tempPrescriptionDrug.availableDosages
        ? tempPrescriptionDrug.availableDosages.map((x: any) => x.name)
        : [],
      frequencyOptions: Object.values(PrescriptionDrugFrequencyEnum),
      currentDosage: tempPrescriptionDrug.currentDosage,
      isEditing: true,
    }
    setAddPrescriptionState({
      ...addPrescriptionState,
      addingDrugs: true,
      PrescriptionDrug: [prescriptionDrugForEditing],
    })
  }

  const handleDeleteDrug = (data: any) => {
    setDeleteDrugLoading(true)
    deletePrescription({ $prescriptionDrugId: data.id, 'for-spouse': data.isSpouse })
      .then((response: any) => {
        if (response.status === 200) {
          if (!forSpouse) {
            pollQuotesPullStatus(getPlanYear())
            customerStore.setQuotePulledStatusMA(true)
            medicareAdvantageFilterQuoteStore.clearStore()
            customerStore.setQuotePulledStatusMPartD(true)
            mPartDPlansFilterStore.clearStore()
          }
          try {
            medicareAdvantageFilterQuoteStore.removeDrugNameOnDeletionOfDrug(data.name)
            mPartDPlansFilterStore.removeDrugNameOnDeletionOfDrug(data.name)
          } catch {}
          snackbarStore.set({
            snackbarMessage: StringConstants.SNACKBAR_DELETE_SUCCESS_MSG,
            snackbarOpen: true,
            snackbarType: SnackbarTypes.SUCCESS,
          })
          const drugListAfterDeletion = addPrescriptionState.AddedDrugs.filter(
            (item) => item.id !== data.id
          )
          if (
            drugListAfterDeletion.length === 0 &&
            customerStore.get().forSpouse === false
          ) {
            ApiManager.makeApiCallWithAuthentication(
              UrlConstants.DELETE_INFO_STEPS.USECASE,
              HttpMethods.DELETE_METHOD,
              { $infoStep: 'prescription' }
            )
              .then((res) => {
                if (res.status === 200) {
                  customerStore.setInfoSteps([
                    ...customerStore.infoSteps.filter(
                      (i: string) => i !== 'prescription'
                    ),
                  ])
                }
              })
              .catch(() => {})
          }
          setAddPrescriptionState({
            ...addPrescriptionState,
            AddedDrugs: drugListAfterDeletion,
          })
        } else throw response
      })
      .catch(() => {
        snackbarStore.set({
          snackbarMessage: 'Failed to delete prescription. Please try again.',
          snackbarOpen: true,
          snackbarType: SnackbarTypes.ERROR,
        })
      })
      .finally(() => setDeleteDrugLoading(false))
  }

  return (
    <Container>
      {isDrugCostsRefreshToBeDisplayed && (
        <ButtonWrapper>
          <div>
            <Button
              fontSize='14px'
              width='100px'
              height='30px'
              variant='contained'
              bold={false}
              onClick={() => {
                setIsDrugCostsToBeRefreshed(true)
                setIsDrugCostsRefreshToBeDisplayed(false)
              }}
            >
              Refresh
            </Button>
          </div>
          <div
            style={{
              display: 'flex',
              color: 'red',
              fontSize: '12px',
              fontWeight: '700',
              width: '100%',
              justifyContent: 'flex-end',
            }}
          >
            * Refresh your prescriptions to view the latest costs
          </div>
        </ButtonWrapper>
      )}
      {isOverlayLoading && <OverlayLoader />}
      {isDrugCostsToBeRefreshed && (
        <ModalComponent
          setOpen={() => {}}
          description='Refresh drug cost prompt'
        >
          <RefreshDrugCostModal
            onConfirm={handleOkRefreshDrugCost}
            onReject={() => {
              setIsDrugCostsToBeRefreshed(false)
              setIsDrugCostsRefreshToBeDisplayed(true)
            }}
          ></RefreshDrugCostModal>
        </ModalComponent>
      )}

      <UpperDiv>
        <QuotesRefreshProvider>
          <SearchPromptComponent
            addPrescriptionState={addPrescriptionState}
            setAddPrescriptionState={setAddPrescriptionState}
            handleNext={handleNext}
            forSpouse={forSpouse}
            loading={loading}
            setLoading={setLoading}
            redirect={redirect}
            addDrugLoading={addDrugLoading}
            setAddDrugLoading={setAddDrugLoading}
            setIsEditDrug={setIsEditDrug}
            isEditDrug={isEditDrug}
          />

          <AddedDrugsWrapper>
            {loading ? (
              <BouncingDotsLoader />
            ) : (
              <>
                <AddedDrugsHeader>
                  <Icon childComponent={<AiOutlinePaperClip />} fontSize='18px' />
                  Added Drugs: {addPrescriptionState.AddedDrugs.length}
                </AddedDrugsHeader>

                {addDrugLoading || deleteDrugLoading ? (
                  <BouncingDotsLoader />
                ) : (
                  <TableWrapper><EntryTable>
                    <thead>
                      <tr>
                        <Th>Drug</Th>
                        <Th>Dose</Th>
                        <Th>Frequency</Th>
                        <Th></Th>
                      </tr>
                    </thead>
                    <tbody>
                      {addPrescriptionState.AddedDrugs.map((item, key) => (
                        <tr key={key} style={{ opacity: isEditDrug ? 0.5 : 1, pointerEvents: isEditDrug ? 'none' : 'auto' }}>
                          <Td>{capitalizeFirstCharacter(item.name)}</Td>
                          <Td>{toSentenceCase(item.currentDosage?.name)}</Td>
                          <Td>
                            {item.currentDosage?.qty} {getFrequencyLabel(item.currentDosage?.frequency)}
                          </Td>
                          <ActionsTd>
                            <IconBtn
                              type='button'
                              onClick={() => handleEditDrug(item)}
                              disabled={
                                customerStore.isSpouseMSEnrollmentApplicationSubmitted ||
                                customerStore.isMSEnrollmentApplicationSubmitted
                              }
                              title='Edit'
                            >
                              <MdEdit size={15} />
                            </IconBtn>
                            <DeleteIconBtn
                              type='button'
                              onClick={() => setPendingDeleteDrug(item)}
                              disabled={
                                customerStore.isSpouseMSEnrollmentApplicationSubmitted ||
                                customerStore.isMSEnrollmentApplicationSubmitted
                              }
                              title='Delete'
                            >
                              <MdDeleteOutline size={15} />
                            </DeleteIconBtn>
                          </ActionsTd>
                        </tr>
                      ))}
                    </tbody>
                  </EntryTable></TableWrapper>
                )}
              </>
            )}
          </AddedDrugsWrapper>
        </QuotesRefreshProvider>
      </UpperDiv>
      {/* {customerStore.getIsMEnabled() &&
        customerStore.getIsSsnProvided() === false &&
        addPrescriptionState.AddedDrugs.length === 0 && (
          <div>
            <div>
              <h2>OR</h2>
              <p>
                Look up list of prescriptions using my Social Security Number
                (SSN)
              </p>
              <Button
                color='primary'
                variant='contained'
                width='220px'
                onClick={() => {
                  setMillimanModalOpen(true)
                }}
              >
                Lookup my prescriptions
              </Button>
            </div>
          </div>
        )} */}
      {/* {millimanModalOpen && (
        <MillimanStepper
          setModalOpen={setMillimanModalOpen}
          setAddPrescriptionState={setAddPrescriptionState}
        />
      )} */}

      {pendingDeleteDrug && (
        <ModalComponent
          setOpen={() => setPendingDeleteDrug(null)}
          description='Popup - Delete Drug Confirmation'
          hideCloseButton={true}
        >
          <DeleteConfirmationModal
            itemLabel='drug'
            onConfirm={() => {
              handleDeleteDrug(pendingDeleteDrug)
              setPendingDeleteDrug(null)
            }}
            onReject={() => setPendingDeleteDrug(null)}
          />
        </ModalComponent>
      )}
    </Container>
  )
}

export default SecureComponent(observer(withRouter(AddPrescription)))
